import { gql } from '@apollo/client'

export const CREATE_CAMPAIGN = gql`
  mutation CreateCampaign($input: CreateCampaignInput!) {
    createCampaign(input: $input) {
      campaign {
        id
        name
        description
        tagId
        priority
        startDate
        endDate
        active
        createdAt
        updatedAt
      }
    }
  }
`

export const UPDATE_CAMPAIGN = gql`
  mutation UpdateCampaign($input: UpdateCampaignInput!) {
    updateCampaign(input: $input) {
      campaign {
        id
        name
        description
        tagId
        priority
        startDate
        endDate
        active
        createdAt
        updatedAt
      }
    }
  }
`

export const DELETE_CAMPAIGN = gql`
  mutation DeleteCampaign($input: DeleteCampaignInput!) {
    deleteCampaign(input: $input) {
      campaign {
        id
      }
    }
  }
`

export const CLONE_CAMPAIGN = gql`
  mutation CloneCampaign($input: CloneCampaignInput!) {
    cloneCampaign(input: $input) {
      campaign {
        id
        name
        description
        tagId
        priority
        startDate
        endDate
        active
        createdAt
        updatedAt
        campaignContent {
          id
          campaignId
          templateId
          sequence
          intervalHours
          template {
            id
            name
            channel
            subjectTemplate
            bodyTemplate
          }
        }
      }
    }
  }
`

export const SET_CAMPAIGN_CONTENT = gql`
  mutation SetCampaignContent($input: SetCampaignContentInput!) {
    setCampaignContent(input: $input) {
      campaignContent {
        id
        campaignId
        templateId
        sequence
        intervalHours
        template {
          id
          name
          channel
          description
          subjectTemplate
          bodyTemplate
        }
      }
    }
  }
`

export const UPDATE_CAMPAIGN_CONTENT = gql`
  mutation UpdateCampaignContent($input: UpdateCampaignContentInput!) {
    updateCampaignContent(input: $input) {
      campaignContent {
        id
        campaignId
        templateId
        sequence
        intervalHours
      }
    }
  }
`
